/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-11 14:30:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-07-15 16:05:05
 * @FilePath: \newpigboxmanger\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import shopdata from '../views/shopdata.vue'
import commodity from '../views/commodity.vue'
import order from '../views/order.vue'
import login from '../views/login.vue'
import store from '../store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
    redirect: '/shop',
    beforeEnter: (to, from, next) => {
      if (store.state.isLogin == true) {
        // alert(111111111)
        next()
      } else {
        // console.log(to);
        // store.commit("setwantGoPath", to.path)
        alert("请先登录！")
        next("/login")
      }
    },
    children: [{
      path: "/shop",
      component: shopdata
    },{
      path: "/commodity",
      component: commodity
    },
    {
      path: "/order",
      component: order
    },
  ]
  },
  {
    path: "/login",
    name: 'Login',
    component: login,
    
  }

]
// routes.beforeEach((to, from, next) => {
//   // ...
// })
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})



export default router
